module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_sand_5-09b676fdfbad608d1808a9c8758192ff.png";